import { render, staticRenderFns } from "./movie-order.vue?vue&type=template&id=4e0418b7&scoped=true"
import script from "./movie-order.vue?vue&type=script&lang=js"
export * from "./movie-order.vue?vue&type=script&lang=js"
import style0 from "./movie-order.vue?vue&type=style&index=0&id=4e0418b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0418b7",
  null
  
)

export default component.exports